<template>
  <div v-if="!opdracht.afhandeling?.tekenaar" class="wrapper">
    <div class="left">
      <span>Koppel aan tekenaar</span>
      <ZoekEnKoppelTekenaar />
    </div>
    <div class="right">
      <span>{{ interestedUsers.length }} Geïnteresseerde tekenaars</span>
      <div v-for="(tek, i) in interestedUsers" :key="i" class="interestedUser">
        <img width="30" :src="tek?.userProfile?.profilePictureURL" alt="" />
        <span>{{ tek?.userProfile?.voornaam }} {{ tek?.userProfile?.achternaam }}</span>
      </div>
    </div>
  </div>
  <div v-else class="wrapper">
    <div class="right" v-if="gekoppeldeTekenaar?.userProfile">
      <span>Gekoppelde tekenaar</span>
      <div class="interestedUser">
        <img width="30" :src="gekoppeldeTekenaar?.userProfile.profilePictureURL" alt="" />
        <span>{{ gekoppeldeTekenaar?.userProfile.voornaam }} {{ gekoppeldeTekenaar?.userProfile.achternaam }}</span>
      </div>
      <br />
      <div v-for="(x, i) in itemsToShow" :key="i" class="itemToShow">
        <span>{{ x }}</span>
        <div>
          {{ gekoppeldeTekenaar?.userProfile[x] }}
        </div>
      </div>
    </div>
    <div v-else>Het profiel van de tekenaar kon niet worden ingeladen. De ID van de tekenaar is: {{ gekoppeldeTekenaar?.id }}</div>
  </div>
</template>

<script>
import ZoekEnKoppelTekenaar from "./ZoekEnKoppelTekenaar.vue"
export default {
  props: ["opdracht"],
  components: { ZoekEnKoppelTekenaar },
  created() {
    let newArrayOfInterestedUsers = []
    if (!this.opdracht.afhandeling?.interestedUsers) return (this.interestedUsers = [])
    this.opdracht.afhandeling?.interestedUsers.forEach(user => {
      let userAccounts = [...this.userAccountsOfTekenaars]
      const newList = userAccounts.filter(e => e.id === user.userId)
      newArrayOfInterestedUsers.push(newList[0])
    })
    this.interestedUsers = newArrayOfInterestedUsers
  },
  setup() {
    const itemsToShow = ["telefoon", "email", "bedrijfsnaam", "plaats"]

    return {
      itemsToShow
    }
  },
  data() {
    return {
      interestedUsers: []
    }
  },
  computed: {
    gekoppeldeTekenaar() {
      if (!this.opdracht.afhandeling?.tekenaar) return {}
      let userAccounts = [...this.userAccountsOfTekenaars]
      return userAccounts.find(e => e.id === this.opdracht.afhandeling?.tekenaar)
    },
    userAccountsOfTekenaars() {
      return this.$store.state.userAccounts
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/utilities/variables.sass'

.itemToShow
  display: flex
  flex-direction: column
  padding: 0 0 10px
  font-size: 15px
  span
    font-size: 12px
    opacity: .3

.wrapper
  border: 2px solid $darkGrey
  flex-wrap: wrap
  display: flex
  overflow: hidden

  .left, .right
    padding: 20px
    flex-grow: 1
    > span
      padding-bottom: 15px
      font-size: 14px


  .left
    box-shadow: 1px 0 0 rgba(0, 0, 0, 0.1)

  .right
    height: 100%
    padding-bottom: 10px
    border-top: 1px solid rgba(0, 0, 0, 0.1)

    .interestedUser
      padding: 10px 0
      display: flex
      align-items: center
      img
        $size: 24px
        border-radius: 100%
        height: $size
        width: $size
        object-fit: cover
      span
        padding-left: 6px
        font-size: 13px
</style>
